import IOverviewApiCall from "./IOverviewApiCall";

abstract class OverviewApiCallBase implements IOverviewApiCall {
    public abstract execute(pointerToComponent, api, id);
}

export default OverviewApiCallBase;